var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.12 5.12L16.59 1.59C16.2142 1.21196 15.703 0.999579 15.17 1H8.83C8.29696 0.999579 7.7858 1.21196 7.41 1.59L3.88 5.12C3.31723 5.68207 3.0007 6.44462 3 7.24V13.09C3.00185 15.5573 4.14207 17.8857 6.09 19.4L10.17 22.58C10.5218 22.853 10.9547 23.0008 11.4 23H12.6C13.0453 23.0008 13.4782 22.853 13.83 22.58L17.91 19.4C19.8579 17.8857 20.9981 15.5573 21 13.09V7.24C20.9993 6.44462 20.6828 5.68207 20.12 5.12ZM19 13.12C19.0079 14.9725 18.1497 16.7223 16.68 17.85L12.6 21H11.4L7.32 17.82C5.8503 16.6923 4.99206 14.9425 5 13.09V7.24C5.0011 6.97766 5.10526 6.72626 5.29 6.54L8.83 3H15.17L18.71 6.54C18.8947 6.72626 18.9989 6.97766 19 7.24V13.12ZM15.12 8C15.3144 7.80943 15.6256 7.80943 15.82 8L16.32 8.52C16.4147 8.61388 16.4679 8.74168 16.4679 8.875C16.4679 9.00832 16.4147 9.13612 16.32 9.23L10.7 14.85C10.6093 14.9467 10.4826 15.0015 10.35 15.0015C10.2174 15.0015 10.0907 14.9467 10 14.85L7.65 12.49C7.55534 12.3961 7.5021 12.2683 7.5021 12.135C7.5021 12.0017 7.55534 11.8739 7.65 11.78L8.18 11.25C8.27073 11.1533 8.39741 11.0985 8.53 11.0985C8.66259 11.0985 8.78927 11.1533 8.88 11.25L10.38 12.74L15.12 8Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.2b988f7c9de4700ce193f11be3b2e8df.svg";
export { ForwardRef as ReactComponent };